import React from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import Brand from '../../menhomethree/Brand'
import First from '../menindustryexportgallery/First'

function Main() {
  return (
    <>
        <Header/>
        <Bredcom title="Home" subtitle="Industry Expert Talks"/>
        <First/>
        {/* <Brand/> */}
    </>
  )
}

export default Main